module.exports = __webpack_public_path__ + "static/media/fenligou.e22c48dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/staticPage/separate/fenligou.jpg
// module id = 480
// module chunks = 0